/**
 * Normalizes layout API payloads whether the server returns `{ layout }` or `{ data: { layout } }`.
 */
export function parseLayoutFromApiResponse(response) {
	const doc = response?.data ?? response;
	const layout = doc?.layout;

	if (layout && typeof layout === "object" && doc?.isFallbackToDefault !== undefined) {
		// We add this as a non-enumerable property so it's available for UI logic
		// (like auto-minimizing) but DOES NOT get serialized to JSON when saving the layout back.
		Object.defineProperty(layout, "isFallbackToDefault", {
			value: !!doc.isFallbackToDefault,
			enumerable: false,
			configurable: true,
		});
	}

	return layout;
}
